/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriverEarningComparisonAdminDto } from '../models/DriverEarningComparisonAdminDto';
import type { DriverEarningDebugAdminDto } from '../models/DriverEarningDebugAdminDto';
import type { DriverSalaryBatchDebugAdminDto } from '../models/DriverSalaryBatchDebugAdminDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DriverEarningsDebugService {
    /**
     * **Required Policy:** `ViewDriverEarning`
     * @returns DriverEarningDebugAdminDto OK
     * @throws ApiError
     */
    public static getEarningBySourceAdmin({
        sourceType,
        sourceId,
    }: {
        sourceType: string,
        sourceId: string,
    }): CancelablePromise<DriverEarningDebugAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driver-earnings/debug/earning/{sourceType}/{sourceId}',
            path: {
                'sourceType': sourceType,
                'sourceId': sourceId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverEarning`
     * @returns DriverSalaryBatchDebugAdminDto OK
     * @throws ApiError
     */
    public static getBatchAdmin({
        batchId,
    }: {
        batchId: string,
    }): CancelablePromise<DriverSalaryBatchDebugAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driver-earnings/debug/batches/{batchId}',
            path: {
                'batchId': batchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverEarning`
     * @returns DriverEarningDebugAdminDto OK
     * @throws ApiError
     */
    public static getDriverEarningsAdmin({
        driverId,
        from,
        to,
        sourceType,
    }: {
        driverId: number,
        from?: string,
        to?: string,
        sourceType?: string,
    }): CancelablePromise<Array<DriverEarningDebugAdminDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driver-earnings/debug/drivers/{driverId}',
            path: {
                'driverId': driverId,
            },
            query: {
                'from': from,
                'to': to,
                'sourceType': sourceType,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverEarning`
     * @returns DriverEarningComparisonAdminDto OK
     * @throws ApiError
     */
    public static getComparisonAdmin({
        sourceType,
        sourceId,
    }: {
        sourceType: string,
        sourceId: string,
    }): CancelablePromise<DriverEarningComparisonAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driver-earnings/debug/comparison/{sourceType}/{sourceId}',
            path: {
                'sourceType': sourceType,
                'sourceId': sourceId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
